<template>
  <div
    class="wave-button"
    v-for="i in wavelength + 1"
    :key="i"
    @click="setWave(i - 1)"
  >
    <img
      src="images/map-current.png"
      alt=""
      style="position: absolute; transform: scale(0.7)"
      class="marker"
      v-if="this.trueNumber == i - 1"
    />
    <img src="images/profile/NightChick.png" alt="" />
  </div>
  <div class="mb-4">
    <el-select v-model="pos">
      <el-option
        v-for="floor in enemy[trueNumber].length"
        :key="floor"
        :label="'Formation ' + floor"
        :value="floor - 1"
      >
        Formation {{ floor
        }}
      </el-option>
    </el-select>
    <br>
    <strong> Formation for this Wave:</strong> {{poslength + 1}}
  </div>
  
  <div class="stage">
    <MDBBtn
      tag="a"
      color="primary"
      floating
      size="lg"
      style="background-color: rgb(172, 43, 172)"
      :class="{ disabled: activeNumber == 0 }"
      @click="waveDecrease"
    >
      <MDBIcon icon="angle-left" iconStyle="fas" size="3x" />
    </MDBBtn>

    <enemy-wave :wave="activeWave" origin="sanctum" />
    <MDBBtn
      tag="a"
      color="primary"
      floating
      size="lg"
      style="background-color: rgb(172, 43, 172)"
      :class="{ disabled: activeNumber >= wavelength }"
      @click="waveIncrease"
    >
      <MDBIcon icon="angle-right" iconStyle="fas" size="3x" />
    </MDBBtn>
  </div>
</template>

<script>
import { MDBIcon, MDBBtn } from "mdb-vue-ui-kit";
import { ElSelect, ElOption } from "element-plus";
import EnemyWave from "./EnemyWave.vue";
export default {
  name: "EnemyStage",
  props: {
    enemy: Object,
  },
  components: {
    EnemyWave,
    ElSelect,
    ElOption,
    MDBIcon,
    MDBBtn,
    // MDBBadge,
  },
  computed: {
    wave() {
      return this.enemy;
    },
    wavelength() {
      return this.wave.length - 1;
    },
    activeWave() {
      return this.wave[this.trueNumber][this.truePos];
    },
    trueNumber() {
      if (this.activeNumber > this.wavelength) {
        this.setWave(this.wavelength);
      }
      if (this.activeNumber < 0) {
        this.setWave(0);
      }
      return this.activeNumber;
    },
    poslength() {
      return this.enemy[this.activeNumber].length - 1;
    },
    truePos() {
      if (this.pos > this.poslength) {
        this.setPos(this.poslength);
      }
      if (this.pos < 0) {
        this.setPos(0);
      }
      return this.pos;
    },
  },
  data() {
    return {
      activeNumber: 0,
      pos: 0,
    };
  },
  methods: {
    waveIncrease() {
      if (this.activeNumber < this.wavelength) {
        this.activeNumber++;
      }
    },
    waveDecrease() {
      if (this.activeNumber > 0) {
        this.activeNumber--;
      }
    },
    setWave(i) {
      this.activeNumber = i;
    },
    setPos(i) {
      this.pos = i;
    },
    getProp(i) {
      return this.wave[this.trueNumber][i].r;
    },
  },
};
</script>

<style>
.stage > * {
  vertical-align: middle;
}
.wave-button {
  margin: 0.5em;
  display: inline-block;
  cursor: pointer;
}
.wave-button img {
  width: 42px;
}
</style>
